// @ts-nocheck
import { Plugin } from '/root/.npm/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request','qiankun','useQiankunStateForSlave','sentry',],
});

export { plugin };
